module.exports = __webpack_public_path__ + "img/crm-title-bg.0538964f.png";